// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    apiUrl: window['serviceUrl'] ? window['serviceUrl'] : 'http://10.10.8.5:8500/',
    recaptchaKey: window['recaptchaKey'] ? window['recaptchaKey'] : '6Ld9W4IUAAAAANsn85CGpgw5NHSywyJZd_ONo7oa',
    // stellenservice: {
    //     title: 'Meffert Job-Angebotsportal',
    //     // typusi: 'http',
    //     ip: '127.0.0.1',
    //     port: '8080',
    //     service: '/stellen?query=',
    //     apiUrl: 'http://' + this.ip + ':' + this.port + this.service
    // }

}
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
